import { FaWhatsapp } from "react-icons/fa";

import BrandMark from "../BrandMark";

const navItems = [
  { label: "Início", href: "/#home" },
  { label: "Áreas", href: "/#areas" },
  { label: "Escritório", href: "/about" },
  { label: "Contato", href: "/#contato" },
];

export default function Header() {
  return (
    <header className="sticky top-0 z-50 border-b border-amber-950/10 bg-[#faf4ea]/98 text-slate-900 shadow-[0_1px_0_rgba(15,23,42,0.04)] backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-2 px-4 py-3 sm:gap-4 sm:py-4 sm:px-6 lg:px-8">
        <a href="/#home" className="flex items-center gap-2 sm:gap-3">
          <BrandMark compact />
          <div className="leading-tight">
            <p
              className="text-[0.98rem] font-bold text-amber-700 sm:text-[1.12rem]"
              style={{
                fontFamily: '"Cormorant Garamond", Georgia, serif',
                letterSpacing: "0.1em",
                wordSpacing: "0.38em",
              }}
            >
              Cleisson Oliveira
            </p>
            <p className="text-[0.72rem] text-slate-500 sm:text-sm">Advocacia</p>
          </div>
        </a>

        <nav className="hidden items-center gap-2 md:flex">
          {navItems.map((item) => (
            <a
              key={item.label}
              href={item.href}
              className="rounded-full px-4 py-2 text-sm font-medium text-slate-700 transition hover:bg-slate-900/5 hover:text-slate-950"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <a
          href="https://wa.me/message/7PUPDXBNVORFM1"
          className="inline-flex items-center gap-2 rounded-full bg-amber-400 px-3 py-2 text-[0.75rem] font-semibold leading-none text-slate-950 transition hover:bg-amber-300 sm:px-4 sm:py-2 sm:text-sm"
        >
          <FaWhatsapp className="text-sm sm:text-base" />
          Falar agora
        </a>
      </div>

    </header>
  );
}
